import parseDate from '../tools/parseDate'

const sortByDate = (a, b, dir = 'DESC') => {
  const aTimestamp = parseDate(a)
  const bTimestamp = parseDate(b)
  if (dir !== 'DESC') {
    return aTimestamp - bTimestamp
  }

  // Más reciente primero
  return bTimestamp - aTimestamp
}

export default sortByDate
